import { FlexColumn, IMAGE_EXTENSIONS } from '@gorila-shared-ui/components';
import { FileRow, FileUploader } from 'baseui/file-uploader';
import { FILE_EXTENSIONS } from '../../constants/app';

type Props = {
  file?: FileRow;
  onFileChange: (file?: FileRow) => void;
  onBlur?: () => void;
  acceptExtensions?: string[];
  externalValidationError?: string;
};

export function DocumentUploader({
  file,
  onFileChange,
  acceptExtensions = [...FILE_EXTENSIONS, ...IMAGE_EXTENSIONS],
  onBlur,
  externalValidationError,
}: Readonly<Props>) {
  return (
    <FlexColumn gap={0}>
      <FileUploader
        accept={acceptExtensions}
        fileRows={file ? [file] : undefined}
        setFileRows={(rows) => {
          if (rows.length > 1) {
            onFileChange(rows[1]);
          } else {
            onFileChange(rows[0]);
          }
        }}
        buttonText="Buscar archivo"
        contentMessage="o arrastra un archivo aquí para subir"
        itemPreview
        onBlur={onBlur}
        multiple={false}
        overrides={{
          FileRowUploadText: {
            props: (props) => {
              if (props?.['aria-invalid']) {
                return {
                  ...props,
                  children:
                    externalValidationError || `Sube archivos: ${acceptExtensions.join(', ')} para un formato válido`,
                };
              }
              if (props.children === 'Uploading') {
                return {
                  ...props,
                  children: 'Cargando...',
                };
              }
              return { ...props, children: 'Archivo válido' };
            },
          },
        }}
      />
    </FlexColumn>
  );
}
